module.exports = __webpack_public_path__ + "img/ИФ-1(А)-018.a7d898fd.png";